import { BUILDER_MODE_V1_LAYOUT } from '../constants';

import type { PopoverContentProps } from '@chakra-ui/react';

/** Popover shell — inner panel uses Figma Select Scenario layout (node 75644:19356) */
const scenarioPopoverContentProperties: PopoverContentProps = {
  w: BUILDER_MODE_V1_LAYOUT.scenarioPopoverWidth,
  bg: 'transparent',
  border: 'none',
  borderRadius: BUILDER_MODE_V1_LAYOUT.scenarioPopoverRadius,
  boxShadow: BUILDER_MODE_V1_LAYOUT.scenarioPopoverShadow,
  _focus: { boxShadow: BUILDER_MODE_V1_LAYOUT.scenarioPopoverShadow },
  mt: '4px',
  zIndex: 20,
  overflow: 'hidden',
};

export default scenarioPopoverContentProperties;
